// extracted by mini-css-extract-plugin
export default {"card":"StatsCard__card___qSQb6","heading":"StatsCard__heading___HtP6g","thickPadding":"StatsCard__thickPadding___w5QbT"};